'use strict';

(function () {
	if (!customElements.get('multi-scroll-gallery')) {

		const centerStickyWrapper = (height, stickyWrapper) => {


			const availableHeight = Math.max(window.innerHeight - height, 0);
			const topOffset = Math.max(availableHeight / 2, 0);
			stickyWrapper.style.top = topOffset + 'px';
			return topOffset;
		};
		class MultiScrollGalllery extends HTMLElement {
			constructor() {
				super();
				this.activeItem = 0;
				this.horizontalSection = this.querySelector('.multi-scroll-gallery__horizontal-section');
				this.stickyWrapper = this.querySelector('.multi-scroll-gallery__sticky-wrapper');
				this.imgWrapper = this.querySelector('.multi-scroll-gallery__right');
				this.contentWrapper = this.querySelector('.multi-scroll-gallery__left');
				this.contentItems = this.querySelectorAll('.multi-scroll-gallery__item');
				this.images = this.querySelectorAll('.multi-scroll-gallery__right .multi-scroll-gallery__image-wrapper');
			}

			connectedCallback() {
				if (this.contentItems.length < 2) {
					return
				}

				this.initScroll();

				window.addEventListener('resize', () => {
					this.initScroll.call(this);
				});
			}
		}


		MultiScrollGalllery.prototype.initScroll = function() {
			// Remove previous scroll listener to prevent duplicates on resize
			if (this._scrollHandler) {
				window.removeEventListener('scroll', this._scrollHandler);
			}

			const galleryHeight = parseInt(this.dataset.galleryHeight) || 400;
			const topOffset = centerStickyWrapper(galleryHeight, this.stickyWrapper);
			const scrollDistance = galleryHeight * this.images.length;

			if (window.innerWidth >= 1200) {
				this.horizontalSection.style.height = `${scrollDistance + topOffset}px`;
				this.imgWrapper.style.maxHeight = `${galleryHeight}px`;
				this.contentWrapper.style.maxHeight = `${galleryHeight}px`;
				this.stickyWrapper.style.maxHeight = `${galleryHeight}px`;
			} else {
				this.horizontalSection.style.height = `auto`;
				this.imgWrapper.style.maxHeight = `100%`;
				this.contentWrapper.style.maxHeight = `100%`;
				this.stickyWrapper.style.maxHeight = `100%`;
				this.imgWrapper.style.transform = `translateY(0)`;
			}

			const onScroll = () => {
				if (window.innerWidth >= 1200) {
					const scrollTop = window.pageYOffset;
					const distFromTop = this.horizontalSection.getBoundingClientRect().top + window.pageYOffset;
					const scrollPosition = Math.max(0, Math.min(scrollTop - distFromTop, scrollDistance - galleryHeight));
					this.imgWrapper.style.transform = `translateY(-${scrollPosition}px)`;

					// Determine active item — round so left switches when right image begins entering
					const activeIndex = Math.min(
						Math.round(scrollPosition / galleryHeight),
						this.images.length - 1
					);

					if (activeIndex !== this.activeItem) {
						this.activeItem = activeIndex;
						this.contentItems.forEach((item, index, arr) => {
							item.classList.remove('active');
							item.classList.remove('prev-item');
							item.classList.remove('next-item');
							if (index === this.activeItem) {
								item.classList.add('active');
							}
							if (this.activeItem > 0 && index === this.activeItem - 1) {
								item.classList.add('prev-item');
							}
							if (index === this.activeItem + 1) {
								item.classList.add('next-item');
							}
						});
					}
				}
			};

			this._scrollHandler = () => {
				requestAnimationFrame(onScroll);
			};

			window.addEventListener('scroll', this._scrollHandler);
			this._scrollHandler();
		};

		customElements.define('multi-scroll-gallery', MultiScrollGalllery);
	}

})();
